import { getImageProps } from 'next/image';

export type ArtDirectedImageSource = {
  src: string;
  width: number;
  height: number;
};

type Props = {
  alt: string;
  className?: string;
  desktop: ArtDirectedImageSource;
  mobile: ArtDirectedImageSource;
  sizes: string;
  quality?: number;
  loading?: 'eager' | 'lazy';
  fetchPriority?: 'high' | 'low' | 'auto';
};

export default function ArtDirectedImage({
  alt,
  className,
  desktop,
  mobile,
  sizes,
  quality,
  loading,
  fetchPriority,
}: Props) {
  const common = { alt, sizes, quality };
  /*
   * loading/fetchPriority 를 getImageProps 에도 그대로 전달해야 한다.
   * getImageProps 내부에서 LCP 감시용 레지스트리(allImgs)에 loading 값이 기록되는데,
   * 전달하지 않으면 loading=undefined → lazy 로 기록되어 <img> 에 eager 를
   * 덮어써도 "LCP 이미지에는 loading=eager 를 추가하라"는 경고가 계속 뜬다.
   */
  const {
    props: { srcSet: desktopSrcSet },
  } = getImageProps({ ...common, ...desktop, loading, fetchPriority });
  const { props: mobileProps } = getImageProps({
    ...common,
    ...mobile,
    loading,
    fetchPriority,
  });

  return (
    <picture className={className}>
      <source media="(min-width: 992px)" srcSet={desktopSrcSet} />
      <img
        {...mobileProps}
        alt={alt}
        loading={loading}
        fetchPriority={fetchPriority}
      />
    </picture>
  );
}
